import { algoliasearch, SearchClient } from "algoliasearch";

const PROJECTS_INDEX = "projects";

let _client: SearchClient | null = null;

function getClient(): SearchClient {
  if (!_client) {
    const appId = process.env.REACT_APP_ALGOLIA_APP_ID || "";
    const searchKey = process.env.REACT_APP_ALGOLIA_SEARCH_KEY || "";
    if (!appId || !searchKey) {
      throw new Error("ALGOLIA_APP_ID and ALGOLIA_SEARCH_KEY must be set");
    }
    _client = algoliasearch(appId, searchKey);
  }
  return _client;
}

export async function searchProjects(
  query: string,
  orgId: string,
): Promise<string[]> {
  if (!query.trim()) return [];

  const result = await getClient().searchSingleIndex({
    indexName: PROJECTS_INDEX,
    searchParams: {
      query,
      filters: `org_id:${orgId}`,
      hitsPerPage: 100,
      attributesToRetrieve: ["objectID"],
    },
  });

  return result.hits.map((hit: any) => hit.objectID);
}

export interface ProjectHit {
  label: string;
  value: string;
  extra_label?: string;
  extra_label_2?: string;
}

export async function searchPartnersFull(
  query: string,
  orgId: string,
): Promise<ProjectHit[]> {
  if (!query.trim()) return [];

  const result = await getClient().searchSingleIndex({
    indexName: "partners",
    searchParams: {
      query,
      filters: `org_id:${orgId}`,
      hitsPerPage: 10,
      attributesToRetrieve: ["objectID", "display_name", "company_name", "role", "company_types"],
    },
  });

  return result.hits.map((hit: any) => ({
    label: hit.company_name || hit.display_name || "",
    value: hit.objectID,
    extra_label: hit.role || "",
    extra_label_2: hit.display_name || "",
  }));
}

export async function searchProjectsFull(
  query: string,
  orgId: string,
): Promise<ProjectHit[]> {
  if (!query.trim()) return [];

  const result = await getClient().searchSingleIndex({
    indexName: PROJECTS_INDEX,
    searchParams: {
      query,
      filters: `org_id:${orgId}`,
      hitsPerPage: 10,
      attributesToRetrieve: ["objectID", "name", "display_name", "num", "city", "address"],
    },
  });

  return result.hits.map((hit: any) => ({
    label: hit.display_name || hit.name || "",
    value: hit.objectID,
    extra_label: [hit.num, hit.city].filter(Boolean).join(" · "),
    extra_label_2: hit.address || "",
  }));
}
